// Positions the current time indicator on the calendar week grid.
// Updates position every minute so the line moves as time passes.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    timeZone: { type: String, default: "UTC" },
    hourHeight: { type: Number, default: 64 }
  }

  connect() {
    this.updatePosition()
    this.intervalId = setInterval(() => this.updatePosition(), 60_000)
  }

  disconnect() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  }

  minutesSinceMidnightInZone() {
    const tz = this.timeZoneValue || "UTC"
    try {
      const now = new Date()
      const formatter = new Intl.DateTimeFormat("en-CA", {
        timeZone: tz,
        hour: "numeric",
        minute: "numeric",
        hour12: false
      })
      const parts = formatter.formatToParts(now)
      const hour = parseInt(parts.find((p) => p.type === "hour")?.value || "0", 10)
      const minute = parseInt(parts.find((p) => p.type === "minute")?.value || "0", 10)
      return hour * 60 + minute
    } catch (e) {
      // Fallback for invalid IANA zone (e.g. Rails names like "Pacific Time (US & Canada)")
      const now = new Date()
      return now.getUTCHours() * 60 + now.getUTCMinutes()
    }
  }

  updatePosition() {
    const minutes = this.minutesSinceMidnightInZone()
    const hourHeight = Number(this.hourHeightValue) || 64
    const topPx = (minutes / 60) * hourHeight

    this.element.style.setProperty("top", `${topPx}px`)
  }
}
